import CancelIcon from "@mui/icons-material/Cancel";
import { Chip } from "@mui/material";

interface Props {
  label: string;
  onDelete: () => Promise<void>;
}

export function FilterChip({ label, onDelete }: Props) {
  return (
    <Chip
      label={label}
      onDelete={() => void onDelete()}
      deleteIcon={<CancelIcon />}
      size="medium"
      variant="filled"
      color="info"
    />
  );
}
